const lazyObjectObserver = new IntersectionObserver(
  (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const lazyObject = entry.target;
        if (lazyObject.dataset.lazyBg) {
          const bgImgSrc = lazyObject.dataset.lazyBg;
          lazyObject.style.backgroundImage = 'url(' + bgImgSrc + ')';
          lazyObject.dataset.lazyBg = '';
          lazyObjectObserver.unobserve(lazyObject);
        }
      }
    });
  },
  {
    root: null, // 'null' = browser viewport
    rootMargin: '0px 0px 0px 0px',
    threshold: 0
  }
);

document.addEventListener('DOMContentLoaded', () => {
  const lazyObjects = Array.from(document.querySelectorAll('[data-lazy-bg]'));
  lazyObjects.forEach((lazyObject) => lazyObjectObserver.observe(lazyObject));
});
